import { UserAPI } from './api/index.js';

export const user = UserAPI.getInstance();
